import { render, staticRenderFns } from "./Catalogo.vue?vue&type=template&id=575b4f8e"
import script from "./Catalogo.vue?vue&type=script&lang=js"
export * from "./Catalogo.vue?vue&type=script&lang=js"
import style0 from "./Catalogo.vue?vue&type=style&index=0&id=575b4f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports